import { render, staticRenderFns } from "./LiveIconBetSlip.vue?vue&type=template&id=78b60ca2&scoped=true&"
import script from "./LiveIconBetSlip.vue?vue&type=script&lang=js&"
export * from "./LiveIconBetSlip.vue?vue&type=script&lang=js&"
import style0 from "./LiveIconBetSlip.vue?vue&type=style&index=0&id=78b60ca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b60ca2",
  null
  
)

export default component.exports